import "./component-library237.mjs";
import normalizeComponent from "./component-library97.mjs";
const _sfc_main = {
  name: "TransitionExpand",
  methods: {
    /* eslint-disable no-param-reassign, no-unused-expressions */
    enter(element) {
      element.style.width = getComputedStyle(element).width;
      element.style.position = "absolute";
      element.style.visibility = "hidden";
      element.style.height = "auto";
      const { height } = getComputedStyle(element);
      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = 0;
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      element.style.height = getComputedStyle(element).height;
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = 0;
      });
    }
    /* eslint-enable no-param-reassign */
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("Transition", { attrs: { "name": "expand" }, on: { "enter": _vm.enter, "after-enter": _vm.afterEnter, "leave": _vm.leave } }, [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "93e284c3",
  null,
  null
);
const TransitionExpand = __component__.exports;
export {
  TransitionExpand as default
};
